import { Inject, Injectable, Injector } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class Addresses_ReportService {

  constructor(
    private injector: Injector
  ) {
  }

  public Addresses: Addresses_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

